import type { HotelSearchResultItem, HotelSearchSavedItemData } from 'tripPlanner/api/types'
import { nonNullable } from 'lib/array/arrayUtils'
import type {
  DrawerHotel,
  DrawerHotelGeoLocation,
  DrawerHotelPrice,
} from './types'

const DEFAULT_NIGHTS = 1

export function composeLocationString(
  city?: string,
  country?: string,
): string {
  return [city, country].filter(Boolean).join(', ')
}

export function mapImages(imageIds: Array<string>): Array<App.Image> {
  return imageIds.map((id) => ({ id }))
}

export function mapGeoLocation(
  geoLocation?: HotelSearchSavedItemData['location']['geoLocation'],
): DrawerHotelGeoLocation | undefined {
  if (!geoLocation) {
    return undefined
  }

  return {
    lat: geoLocation.lat,
    lng: geoLocation.lng,
  }
}

export function mapPrice(
  price?: number,
  numberOfNights?: number,
  currencyCode?: string,
): DrawerHotelPrice | undefined {
  if (price === undefined || price <= 0) {
    return undefined
  }

  return {
    total: price,
    nights: numberOfNights ?? DEFAULT_NIGHTS,
    currency: currencyCode,
  }
}

export function mapToDrawerHotel(item: HotelSearchResultItem): DrawerHotel | undefined {
  const { savedItemData } = item

  if (!savedItemData?.imageIds?.length) {
    return undefined
  }

  const { location } = savedItemData

  return {
    id: savedItemData.offerId,
    offerId: savedItemData.offerId,
    offerType: savedItemData.offerType,
    slug: item.slug,
    name: item.name,
    description: item.description || undefined,
    location: composeLocationString(location.city, location.country),
    images: mapImages(savedItemData.imageIds),
    rating: savedItemData.rating,
    price: mapPrice(savedItemData.price, item.numberOfNights, savedItemData.currencyCode),
    value: savedItemData.value,
    discountPercent: savedItemData.discountPercent,
    geoLocation: mapGeoLocation(location.geoLocation),
    deeplinkUrl: item.deeplinkUrl,
    checkIn: savedItemData.checkIn,
    checkOut: savedItemData.checkOut,
  }
}

export function mapToDrawerHotels(items: Array<HotelSearchResultItem>): Array<DrawerHotel> {
  return nonNullable(items.map(mapToDrawerHotel))
}
